import React from 'react';
import { VipSignupGuide } from './vip/VipSignupGuide';
import './vip/vip.css';

export const LeaderboardSignupGuide = ({ board }) => <div className="vip-page leaderboard-signup-section" data-testid={`leaderboard-${board}-signup-section`}>
  <VipSignupGuide key={board} prefix={`leaderboard-${board}`} />
</div>;